import { render, staticRenderFns } from "./VehicleCostDetails.vue?vue&type=template&id=1be15dd4"
import script from "./VehicleCostDetails.vue?vue&type=script&lang=js"
export * from "./VehicleCostDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports